import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'ngx-adiciona-contato',
  templateUrl: './adiciona-contato.component.html',
  styleUrls: ['./adiciona-contato.component.scss']
})
export class AdicionaContatoComponent implements OnInit {

  formulario: FormGroup

  constructor(public dialogRef: MatDialogRef<AdicionaContatoComponent>) { }

  ngOnInit(): void {

  }

  formataObjContato(body) {
    let objContato = {
      Id: 0,
      Nome: body.NomeUsuarioWpp,
      Email: '',
      TelefonePrincipal: body.Telefone,
      TelefoneSecundario: '',
      PosicaoFuncional: '',
      Aniversario: '',
      idEmpresa: this.formulario.value.Empresa.Id
    }

    return objContato
  }
}
